<template>
  <div class="container-fluid">
    <div class="card card-box mb-5 my-3">
      <div class="card-header bg-card-header text-white">
        <h5 class="my-3">
          Danh sách E Voucher chờ xác nhận
        </h5>
      </div>
      <div class="card-body py-0">
        <div class="row">
          <div
            v-for="eVoucher in voucherList"
            :key="eVoucher.id"
            class="col-md-6 col-sm-6 col-lg-3 mt-4"
          >
            <div
              style="box-shadow: rgb(102 187 106 / 31%) 3px 6px; height: 200px; border: 1px solid #66bb6a; position: relative;"
            >
              <div
                class="mt-2"
                style="background-color: #66bb6a; color: #fff; display: inline-block; position: relative;"
              >
                <div style="padding: 5px; padding-left: 10px;">
                  Giảm {{ convertToMoney(eVoucher.value) }} VNĐ
                  <div class="arrow-right" />
                </div>
              </div>
              <div style="clear: both;"></div>
              <div
                style="background-color: red; color: #fff; display: inline-block; position: relative;"
              >
                <div class="px-4 small" style="padding: 3px;">
                  Hết hạn sau: {{ getRemainDays(eVoucher.endDate) }} ngày
                </div>
              </div>
              <div class="p-2 my-2 small font-italic">
                <span style="color: red;" class="font-weight-bold ml-1">* </span>
                <span>{{ "Chú ý" }}: {{ `E Voucher sẽ bị huỷ vào lúc ${eVoucher.expiredDate} nếu quý khách không xác nhận.` }}</span>
              </div>
              <div style="position: absolute; bottom: 0; left: 50%; transform: translate(-50%, -0%);">
                <div style="display: flex;">
                  <b-button size="sm" class="m-2" variant="outline-success" @click="onConfirmEVoucher(eVoucher)">Xác nhận</b-button>
                  <b-button size="sm" class="m-2" variant="outline-danger" @click="onRejectEVoucher(eVoucher)">Huỷ</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <b-pagination
          @change="onChangePage"
          v-model="paginator.currentPage"
          :total-rows="paginator.totalPage"
          :per-page="paginator.pageSize"
          align="center"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import dateUtils from "Utils/dateUtils";
import VoucherStatusType from "Enum/voucherStatusType";
import moment from "moment";
import EntityType from "Enum/entityType";
import functionUtils from "Utils/functionUtils";
export default {
  data: () => ({
    voucherList: [],
    bordered: true,
    paginator: {
      currentPage: 1,
      totalPage: 1,
      pageSize: 1,
    },
  }),
  computed: {
    ...mapGetters(["ISSUE_E_VOUCHER_QUEUE_DATA", 'GET_CURRENT_ACCOUNT']),
  },
  watch: {
    ISSUE_E_VOUCHER_QUEUE_DATA() {
      var data = this.ISSUE_E_VOUCHER_QUEUE_DATA;
      // Handle paginate
      this.paginator.currentPage = data.paginate.currentPage;
      this.paginator.totalPage = data.paginate.totalPage;
      this.paginator.pageSize = data.paginate.perPage / 2;
      // Handle response data
      let issueEVoucherQueueList = data.results;
      this.voucherList = [];
      for (let i = 0, size = issueEVoucherQueueList.length; i < size; i++) {
        let issueEVoucherQueue = {
          no: i + 1 + (data.paginate.currentPage - 1) * data.paginate.pageSize,
          id: issueEVoucherQueueList[i].id,
          voucherId: issueEVoucherQueueList[i].voucher.id,
          name: issueEVoucherQueueList[i].voucher.name,
          // serial: issueEVoucherQueueList[i].voucher.serial,
          expiredDate: dateUtils.formatDate(
            issueEVoucherQueueList[i].date_expired,
            dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
            dateUtils.STATIC_FORMAT_TIME_DATE
          ),
          fromEntity: issueEVoucherQueueList[i].from_entity,
          value: issueEVoucherQueueList[i].voucher.value,
          endDate: this.getEndDateEVoucher(
            issueEVoucherQueueList[i].voucher.end_date
          ),
        };
        this.voucherList.push(issueEVoucherQueue);
      }
    },
  },
  created() {
    this.getIssueEVoucherQueueList();
  },
  methods: {
    /**
     * Get end date e voucher
     */
    getEndDateEVoucher: function(endDate) {
      if (!functionUtils.isNull(endDate)) {
        return dateUtils.formatDate(
          endDate,
          dateUtils.STATIC_FORMAT_DATE_TIME_ZONE,
          dateUtils.STATIC_FORMAT_DATE
        );
      } else {
        return "";
      }
    },
    /**
     * Get remain days
     */
    getRemainDays: function(endDate) {
      return dateUtils.getRemainDays(endDate)
    },
    /**
     * Convert to money
     */
    convertToMoney: function(value) {
      return functionUtils.convertFormatNumberToMoney(value);
    },
    /**
     * Check not expired date
     */
    isNotExpiredDate: function(item) {
      let currentDate = moment().format("DD/MM/YYYY HH:mm");
      if (currentDate > item.expiredDate) {
        return false;
      }
      return true;
    },
    /**
     * Get status
     */
    getStatus: function(item) {
      let currentDate = moment().format("DD/MM/YYYY HH:mm");
      if (currentDate > item.expiredDate) {
        return "E Voucher đã hết hạn";
      } else {
        return "Chờ xác nhận";
      }
    },
    /**
     * Page change
     */
    onChangePage: function(page) {
      this.paginator.currentPage = page;
      this.getIssueEVoucherQueueList();
    },
    /**
     * Get issue e voucher queue list
     */
    getIssueEVoucherQueueList: function() {
      let filter = {
        params: {
          page: this.paginator.currentPage
        },
      };
      this.GET_ISSUE_E_VOUCHER_QUEUE(filter);
    },
    /**
     * Confirm e voucher
     */
    onConfirmEVoucher: function(item) {
      this.$swal
        .fire({
          title: "Xác nhận E Voucher?",
          text: `Bạn có chắc muốn xác nhận E Voucher này?`,
          icon: "question",
          showCancelButton: true,
          inputAttributes: {
            autocapitalize: 'off'
          },
          confirmButtonColor: "#66bb6a",
          cancelButtonColor: "#d33",
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Huỷ",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            let filter = {
              voucherId: item.voucherId,
              status: VoucherStatusType.ASSIGNED,
              fromEntity: item.fromEntity ? item.fromEntity : null,
              fromEntityType: EntityType.CUSTOMER,
            };
            return this.CONFIRM_VOUCHER_ASSIGNED(filter).then(
              function() {
                this.paginator.currentPage = 1;
                this.getIssueEVoucherQueueList();
                this.$swal.fire(
                  "Đã xác nhận!",
                  "E Voucher của bạn đã xác nhận.",
                  "success"
                );
              }.bind(this)
            ).catch(
              function (error) {
                this.$swal.showValidationMessage(this.$t(functionUtils.errorResponse(error.response)))
              }.bind(this)
            )
          },
          allowOutsideClick: () => !this.$swal.isLoading()
        })
        .then((result) => {
          if (result.value) {
            this.paginator.currentPage = 1;
            this.getIssueEVoucherQueueList();
          }
        });
    },
    /**
     * Reject e voucher
     */
    onRejectEVoucher: function(item) {
      this.$swal
        .fire({
          title: "Huỷ E Voucher?",
          text: `Bạn có chắc muốn huỷ E Voucher này?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#66bb6a",
          cancelButtonColor: "#d33",
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Huỷ",
        })
        .then((result) => {
          if (result.value) {
            let filter = {
              voucherId: item.voucherId,
              status: VoucherStatusType.ACTIVATED,
              fromEntityType: EntityType.CUSTOMER,
            };
            this.CONFIRM_VOUCHER_ASSIGNED(filter).then(
              function() {
                this.paginator.currentPage = 1;
                this.getIssueEVoucherQueueList();
                this.$swal.fire(
                  "Đã huỷ!",
                  "E Voucher của bạn đã bị huỷ.",
                  "success"
                );
              }.bind(this)
            );
          }
        });
    },
    ...mapActions(["GET_ISSUE_E_VOUCHER_QUEUE", "CONFIRM_VOUCHER_ASSIGNED"]),
  },
};
</script>

<style lang="scss" scoped>
.arrow-right {
  width: 0;
  height: 0;
  border-top: 17px solid transparent;
  border-bottom: 17px solid transparent;
  border-left: 20px solid #66bb6a;
  position: absolute;
  top: 0;
  right: -20px;
}
</style>
